import useSWR from "swr";
import { createProductServiceAxiosClient } from "../createProductServiceAxiosClient.ts";
import { NormasTeachingItemType } from "../../Stripe/StripeOrderDTO.ts";
import { CouponType } from "./CouponType.ts";

export { CouponType };

export type ApplicableProduct = {
  itemType: NormasTeachingItemType;
  id: string;
};

export type NormasTeachingCouponDTO = {
  _id: string;
  couponCode: string;
  value: { amount: number; couponType: CouponType };
  maxNumberOfUses: number;
  validFrom?: string;
  validTo?: string;
  isActive: boolean;
  applicableProducts?: ApplicableProduct[];
  isUnlimitedUses?: boolean;
};

export function useNormasTeachingCouponById(couponId: string) {
  const { data, isLoading } = useSWR(`/coupons/${couponId}`, async (url) => {
    const { data } =
      await createProductServiceAxiosClient().get<NormasTeachingCouponDTO>(url);
    return data;
  });

  return {
    coupon: data,
    isLoading,
  };
}
